import React from 'react'
import { Compass, Ship, ArrowRight, MessageSquare } from 'lucide-react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Waves, Clock, Sparkles } from 'lucide-react';
import {  Camera, Users, Sunset } from "lucide-react";
import {  Award,  MapPin, Anchor, Settings } from "lucide-react";
// import {    Sunset } from 'lucide-react';
import { Briefcase,   Shield } from 'lucide-react';

import FAQSection from '../Components/FAQSection';

const familyFaqs = [
  {
    question: "What is a family yacht party in Mumbai like?",
    answer: "A family yacht party in Mumbai is a private on-water experience where families and close groups spend quality time together in a scenic and exclusive setting."
  },
  {
    question: "Is a private yacht party suitable for family groups?",
    answer: "Yes. A private yacht party is ideal for family gatherings, private celebrations and meaningful time with loved ones."
  },
  {
    question: "What can we do during a family yacht party?",
    answer: "Guests often enjoy private cruising, family time, photos, music, sunset views and celebration moments with their group."
  },
  {
    question: "Which yacht should I choose for up to 15 guests?",
    answer: "For up to 15 guests, a private yacht charter is usually the best option because it feels more intimate and comfortable."
  },
  {
    question: "Which yacht should I choose for more than 15 guests?",
    answer: "For more than 15 guests, a yacht party format is usually more suitable because it works better for larger private groups."
  },
  {
    question: "Is this suitable for multi-generation family groups?",
    answer: "Yes. Family yacht parties can work very well for parents, children, grandparents and mixed-age groups."
  },
  {
    question: "How is Indiaboats different for family and private celebrations?",
    answer: "Indiaboats focuses on premium on-water experiences and helps guests choose the right format for smooth, scenic and memorable private outings."
  },
  {
    question: "How do I enquire about a family or private yacht party in Mumbai?",
    answer: "You can enquire through WhatsApp or the contact form and share your date, guest count and occasion."
  }
];


const FamilyEvents = () => {
    const businessNauticalOptions = [
    {
      type: "networking",
      badge: "RELATIONSHIP BUILDING",
      title: "Corporate Events & Networking",
      objective: "Client hosting, executive networking, premium hospitality, and business relationship-building",
      desc: "If your main objective is client hosting, executive networking, premium hospitality and business relationship-building, then a Corporate Events & Networking yacht format is usually the best fit.",
      linkText: "Corporate Yacht Events for Networking and Hosting",
      linkUrl: "#corporate-networking",
      icon: <Briefcase size={24} />
    },
    {
      type: "teambuilding",
      badge: "ACTIVE COLLABORATION",
      title: "Corporate Sailing Regattas",
      objective: "Team building, collaboration, leadership development, and active participation",
      desc: "If your main objective is team building, collaboration, leadership development and active participation, then a Corporate Sailing Regatta is usually more suitable.",
      linkText: "Corporate Sailing Regattas for Team Building",
      linkUrl: "#corporate-regattas",
      icon: <Compass size={24} />
    }
  ];




// Data object defined inside the component body for better maintainability.
  const ibBoatSelectorData = {
    title: "Which Boat Option Is Right for Your Trip",
    primaryParagraph: "The right boat for an Alibaug or Elephanta tour depends mainly on your group size, comfort preference and travel style.",
    secondaryParagraph: "For smaller private groups, couples and families, a speed boat or compact private transfer option is usually ideal. For bigger groups or premium outings, a larger private boat option may be more suitable depending on the number of guests and the style of travel you want.",
    ctaText: "Explore Private Speed Boat Transfers from Mumbai"
  };

  
  // Unique data structure for project-safe variable naming
  
  return (
    <>
        <Header/>

          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">
      {/* 1. HERO HEADER */}
      <section className="aeb-hero">
        <div className="aeb-container">
          <div className="aeb-hero-grid">
            
            {/* Text Column */}
            <div className="aeb-hero-content">
              
              <h1 className="aeb-hero-title">
               Family & Private Yacht Parties in Mumbai
              </h1>
              <p className="aeb-hero-subtext">
                Enjoy quality time with your loved ones on a private yacht in Mumbai. Discover family yacht parties, private celebrations, scenic cruises and memorable moments on the water with Indiaboats.
              </p>
              
              <div className="aeb-hero-btn-stack">
                <a href="#plan" className="th-btn style3 th-icon">
                  Plan Your Private Celebration
                  <ArrowRight size={16} />
                </a>
                <a href="https://wa.me/917977600563" className="aeb-btn aeb-btn-whatsapp" target="_blank" rel="noopener noreferrer">
                  <MessageSquare size={16} fill="currentColor" />
                  Enquire on WhatsApp
                </a>
                <a href="#options" className="aeb-btn aeb-btn-secondary">
                  Explore Yacht Options
                </a>
              </div>
            </div>

            {/* Visual Column */}
            <div className="aeb-hero-media">
              <div className="aeb-image-frame">
                <img 
                  src="https://images.unsplash.com/photo-1562281302-809108fd533c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                  alt="Premium Yacht sailing away from Gateway of India, Mumbai" 
                  className="aeb-media-img" 
                />
                <div className="aeb-floating-card">
                  <Ship size={20} className="aeb-floating-icon" />
                  <div>
                    <span className="aeb-floating-title">Premium Fleet Only</span>
                    <span className="aeb-floating-desc">Catering to comfort & style</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 2. TRUST STRIP */}
   <div className="aeb-trust-strip">
  <div className="aeb-container">
    <div className="aeb-trust-flex">
    
      
      <span className="aeb-trust-item">Family Yacht Party Mumbai</span>
      <span className="aeb-trust-divider">|</span>
      
      <span className="aeb-trust-item">Private Yacht Celebration</span>
      <span className="aeb-trust-divider">|</span>
      
      <span className="aeb-trust-item">Family Friendly</span>
      <span className="aeb-trust-divider">|</span>
      
      <span className="aeb-trust-item">Scenic Sea Views</span>
      <span className="aeb-trust-divider">|</span>
      
      <span className="aeb-trust-item">Premium Private Experiences</span>
    </div>
  </div>
</div>

      {/* 3. ESCAPE INTRO DUO */}
      <section className="aeb-intro-section">
        <div className="aeb-container">
          <div className="aeb-intro-grid">
            
            <div className="aeb-intro-header-col">
             
              <h2 className="aeb-intro-title">
              A Private Yacht Celebration with the People Who Matter Most
              </h2>
              <div className="aeb-title-accent"></div>
            </div>

            <div className="aeb-intro-body-col">
              <p className="aeb-intro-paragraph">
                A family or private yacht party in Mumbai offers a beautiful way to spend meaningful time with your loved ones in a more exclusive and memorable setting. Instead of a crowded venue or an ordinary outing, a private yacht gives you your own celebration space on the water with sea views, comfort and privacy.
              </p>
              <p className="aeb-intro-paragraph">
               Whether you are planning family time, a private gathering, a reunion, a quiet celebration or simply a special outing with close people, a yacht creates a setting that feels more personal and more enjoyable. The experience is not only about being on a boat — it is about sharing moments together in a scenic and premium environment.
              </p>
              <p className="aeb-intro-paragraph aeb-highlight-text">
               With Indiaboats, family and private yacht parties in Mumbai feel smoother, more comfortable and more thoughtfully planned.
              </p>
            </div>

          </div>
        </div>
      </section>
      </div>

 <section className="aeb-better-section">
      <div className="aeb-container">
        <div className="aeb-better-grid">
          
          {/* Left Content Side */}
          <div className="aeb-better-content-col">
            
            <h2 className="aeb-better-section-title">
            Why a Family or Private Yacht Party Feels So Different
            </h2>
            
            <div className="aeb-better-paragraphs">
              <p className="aeb-better-p">
               A private yacht party feels special because it gives your group time and space away from the noise of conventional venues. There are no crowded banquet rooms, no public interruptions and no ordinary surroundings. Instead, there is open water, fresh air, privacy and a slower, more meaningful atmosphere.
              </p>
              <p className="aeb-better-p">
                For families, it becomes a way to enjoy quality time together. For private groups, it becomes a celebration that feels more exclusive and better suited to personal moments. The sea naturally adds calm, beauty and a sense of occasion that makes the entire experience stand out.
              </p>
             
            </div>

            {/* Callout Highlight Block */}
            <div className="aeb-highlight-banner">
              <Sparkles className="aeb-highlight-icon" size={24} />
              <p className="aeb-highlight-banner-text">
                No crowds. No noise. Just your people and the sea.
              </p>
            </div>
          </div>

          {/* Right Interactive/Feature Side */}
          <div className="aeb-better-features-col">
            <div className="aeb-feature-visual-card">
              <img 
                src="https://images.unsplash.com/photo-1562281302-809108fd533c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="Private luxury speedboat on open sea with wake" 
                className="aeb-feature-img"
              />
              
              <div className="aeb-amenities-stack">
                <div className="aeb-amenity-pill">
                  <Waves className="aeb-pill-svg" size={16} />
                  <span>No Road Congestion</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Clock className="aeb-pill-svg" size={16} />
                  <span>Direct Open Water Routes</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Compass className="aeb-pill-svg" size={16} />
                  <span>Exclusive Group Setting</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      </section>

       

      <section className="tds-main-section">
  <div className="tds-container">
    
    {/* Top Section - Split Header and Intro */}
    <div className="tds-top-split-grid">
      <div className="tds-content-column">
       
        <h2 className="tds-section-title">
         Things to Do During a Family or Private Yacht Party
        </h2>
      </div>
      
      <div className="tds-intro-column">
        <p className="tds-p">
         A family and private yacht party in Mumbai can be relaxed, scenic and celebration-led depending on your group and the kind of outing you want.
        </p>
      </div>
    </div>

    {/* Bottom Section - 8-Item Highlights Grid */}
   <div className="tds-highlights-grid">
  {[
    { title: "Private Family Time", desc: "Enjoy private family time on the water" },
    { title: "Celebrate Occasions", desc: "Celebrate a special occasion with loved ones" },
    { title: "Escape Crowded Venues", desc: "Spend quality time away from crowded venues" },
    { title: "Scenic Photography", desc: "Take beautiful group and family photos with sea views" },
    { title: "Music & Celebration", desc: "Enjoy music and light celebration moments onboard" },
    { title: "Peaceful Private Cruise", desc: "Plan a peaceful private cruise with your close group" },
    { title: "Family Reunions", desc: "Host a family reunion or intimate private event" },
    { title: "Sunset Skyline", desc: "Watch the sunset and enjoy the Mumbai skyline" }
  ].map((item, index) => (
    <div key={index} className="tds-card">
      <div className="tds-card-top-accent"></div>
      <div className="tds-card-icon-box">
        {index % 4 === 0 && <Users size={20} />}
        {index % 4 === 1 && <Sparkles size={20} />}
        {index % 4 === 2 && <Waves size={20} />}
        {index % 4 === 3 && <Camera size={20} />}
      </div>
      <h5 className="tds-card-title">{item.title}</h5>
      <p className="tds-card-desc">{item.desc}</p>
    </div>
  ))}
</div>
  </div>
</section>

    <section className="exp-section">
  <div className="exp-container">
    
    {/* Section Header */}
    <div className="exp-header">
      <h2 className="exp-title">What the Experience Feels Like</h2>
      <div className="exp-divider"></div>
    </div>

    {/* Main Content Grid */}
    <div className="exp-content">
      <p className="exp-main-text">
        A family or private yacht party feels calm, spacious and personal. The moment your group steps onboard, the mood changes from routine to memorable. The setting feels open and refreshing, and the time spent together feels more focused and more enjoyable because your group has its own private environment.
      </p>

      <p className="exp-main-text">
        For families, it can feel warm, comfortable and relaxed. For private groups, it can feel elegant, scenic and special. The beauty of the sea and the privacy of the yacht create an experience that feels more thoughtful than a regular outing.
      </p>

      
    </div>
  </div>
</section>

      <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Celebrate with Indiaboats
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> offers premium yacht experiences in Mumbai and helps guests create family and private yacht parties that feel smooth, scenic and genuinely memorable. We understand that private celebrations are personal, so the focus is on making the overall experience easy, comfortable and enjoyable.
      </p>
      <p>
        From helping you understand which yacht suits your group size to guiding you toward the right format, Indiaboats makes it easier to plan private family celebrations and meaningful gatherings on the water.
      </p>
    </div>

    <div className="ib-luxury-feature-grid">
  {[
    { title: "Premium Experience", desc: "Premium family yacht experience in Mumbai", icon: <Ship size={24} /> },
    { title: "Celebration Ready", desc: "Ideal for private and family celebrations", icon: <Sparkles size={24} /> },
    { title: "Versatile Groups", desc: "Suitable for intimate groups and larger gatherings", icon: <Users size={24} /> },
    { title: "Scenic Atmosphere", desc: "Beautiful sea views and private atmosphere", icon: <Waves size={24} /> },
    { title: "Exclusive Venue", desc: "More exclusive than ordinary venues", icon: <Anchor size={24} /> },
    { title: "Expert Guidance", desc: "Guidance on choosing the right yacht option", icon: <MapPin size={24} /> },
    { title: "Smooth Planning", desc: "Smooth and experience-led planning", icon: <Settings size={24} /> }
  ].map((item, index) => (
    <div key={index} className="ib-luxury-feature-card">
      <div className="ib-luxury-feature-icon-box">{item.icon}</div>
      <div className="ib-luxury-feature-card-content">
        <h4>{item.title}</h4>
        <p>{item.desc}</p>
      </div>
    </div>
  ))}
</div>
  </div>
</section>

      <section className="ib-boat-selector-wrapper">
  <div className="ib-boat-selector-container">
    <h2 className="ib-boat-selector-headline">Which Yacht Option Is Right for Your Group</h2>
    <p className="ib-boat-selector-text">
      The right yacht mainly depends on your group size and how intimate or spacious you want the experience to feel.
    </p>
    <p className="ib-boat-selector-text">
      If your family or private yacht party is for up to 15 guests, a private yacht charter is usually the best option. It is ideal for close families, intimate gatherings and smaller private celebrations.
    </p>
    <p className="ib-boat-selector-text">
      If your group is more than 15 guests, a yacht party format is usually more suitable. Larger yachts offer better space and movement for bigger private gatherings and family events.
    </p>

    {/* Internal Link Blocks */}
    <div className="ib-boat-selector-cta-group" style={{}} id='family_option'>
      <a href="/private-yacht-charters" className="ib-boat-selector-cta-block">
        <span className="ib-boat-selector-cta-text">Private Yacht Charters for Up to 15 Guests</span>
        <svg className="ib-boat-selector-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>

      <a href="/yacht-parties" className="ib-boat-selector-cta-block">
        <span className="ib-boat-selector-cta-text">Yacht Party Options for More Than 15 Guests</span>
        <svg className="ib-boat-selector-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </div>
  </div>
</section>

     <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
     
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Family yacht party in Mumbai ",
        "Private yacht celebration with loved ones",
        "Family reunion on a yacht",
        "Small private group gatherings",
        "Premium private sea outings",
        "Multi-generation family occasions",
        "Scenic private celebrations in Mumbai",
       
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>

<section className="cxe-main-section">
  <div className="cxe-container">
    
    {/* Editorial Section Header */}
    <div className="cxe-header-block">
      <div className="cxe-tag-row">
        <Shield size={14} className="cxe-shield-icon" />
        <span className="cxe-pre-title">Event Selection</span>
      </div>
      <h2 className="cxe-section-title">
        Which Yacht Option <span className="cxe-light-text">Is Right for Your Group</span>
      </h2>
      <p className="cxe-section-subtitle">
        Select the ideal format for your family gathering based on guest size and desired ambiance.
      </p>
    </div>

    {/* Side-by-Side Architectural Decision Grid */}
    <div className="cxe-decision-grid">
      {[
        {
          title: "Private Yacht Party in Mumbai for Up to 15 Guests",
          desc: "For smaller family gatherings and intimate private celebrations, a private yacht charter is usually the best choice. It offers a quieter, more personal and more comfortable environment for meaningful time together.",
          linkText: "Explore Private Yacht Charters for Up to 15 Guests",
          linkUrl: "/private-yacht-charters",
          badge: "Intimate",
          type: "small"
        },
        {
          title: "Private Yacht Party in Mumbai for More Than 15 Guests",
          desc: "For larger family occasions and bigger private groups, a yacht party format offers more guest space and a better setup for a comfortable and memorable group celebration on the water.",
          linkText: "Explore Yacht Parties for More Than 15 Guests",
          linkUrl: "/yacht-parties",
          badge: "Spacious",
          type: "large"
        }
      ].map((option, index) => (
        <div 
          key={index} 
          className={`cxe-decision-card ${option.type === "large" ? 'cxe-card-dark' : 'cxe-card-light'}`}
        >
          <div className="cxe-card-accent-line"></div>
          
          <div className="cxe-card-header">
            <div className="cxe-icon-box">
              {option.type === "small" ? <Users size={20} /> : <Ship size={20} />}
            </div>
            <span className="cxe-card-badge">{option.badge}</span>
          </div>

          <div className="cxe-card-body">
            <h3 className="cxe-card-title">{option.title}</h3>
            <p className="cxe-card-desc">{option.desc}</p>
          </div>

          <div className="cxe-card-footer">
            <a href={option.linkUrl} className="cxe-anchor-link">
              <span>{option.linkText}</span>
              <div className="cxe-arrow-wrapper">
                <ArrowRight size={16} />
              </div>
            </a>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>

      

    <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
          When you plan a family or private yacht party with Indiaboats, the experience is designed to feel premium, comfortable and simple to organise. We help you understand which yacht format suits your group size, what type of experience works best for your occasion and how to make the outing feel special from start to finish.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Premium private yacht experience",
          "Guidance based on group size and occasion",
          "Suitable options for intimate and larger groups",
          "Scenic sea views and private atmosphere",
          "More meaningful alternative to ordinary venues",
          "Supportive and experience-led planning"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
           At Indiaboats, safety is central to every family and private yacht party. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so your celebration feels enjoyable, private and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  title="Frequently Asked Questions About Family & Private Yacht Parties"
  faqData={familyFaqs}
/>

 <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
            Plan a Family or Private Yacht Celebration That Feels 
            <span>Truly Special</span>
          </h2>

          <p className="igxParagraphText">
            Discover how a private yacht party in Mumbai can turn family time and private celebrations into memorable moments on the water. Explore the best options for intimate groups and larger gatherings with Indiaboats.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Plan Your Celebration</span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Private Yacht Charters</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Explore Yacht Parties</span>
            </button>

          </div>
        </div>
      </div>
    </section>

     <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Family Event</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

       <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Occasion</label>
      <select>
        <option>Select occasion</option>
        <option>Family Gathering</option>
        <option>Birthday Celebration</option>
        <option>Anniversary</option>
        <option>Family Reunion</option>
        <option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your private party requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Enquire Now</span>
  </button>
</form>
        </div>
      </div>
    </section>

            </div>


<Footer/>
</>
  )
}

export default FamilyEvents
